exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".media-library-item[data-v-558701ea] {\n  width: 100%;\n  text-align: center;\n  display: inline-block;\n  padding-top: 5px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.media-library-item[data-v-558701ea]:hover {\n    cursor: pointer;\n}\n", ""]);

